export default __webpack_public_path__ + "img/dwQwcXTG.8139a0ac.svg";